// Denied (403) page strings (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'denied.head': 'Access denied',
  'denied.title': 'Access denied',
  'denied.body':
    "You don't have permission to view this page. If you think this is a mistake, ask an administrator.",
  'denied.back': 'Go back',
  'denied.home': 'Dashboard',
}

export const zhTW = {
  'denied.head': '存取被拒',
  'denied.title': '存取被拒',
  'denied.body': '您沒有檢視此頁面的權限。若您認為這是錯誤，請聯絡管理員。',
  'denied.back': '返回',
  'denied.home': '儀表板',
}
